import React,{useContext,useState,useEffect} from 'react'
import { useHistory } from "react-router-dom";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/core/styles';
import { Box,Card  ,CardContent ,Typography,IconButton,TextField,    
    FormControl ,Select as MaterialSelect ,
    InputLabel,
    Button} from '@material-ui/core'
import TablaRenta from './TablaRenta';
import RepoTab from './RepoTab';
import moment from 'moment';
import Relojes from './Relojes2'
import NuevaOrden from './ModalNvo'
import axios from 'axios';
import qs from 'qs';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import {llamadaApiToken,ErrorGeneral } from '../funciones/ClienteAxios';
import ModalEditar from './ModalEditar2';
import {findNumber} from "../funciones/FindNumber";
import NumberFormat from 'react-number-format';
import ModalNvoProveedor from './ModalNvoProvee';
const useStyles = makeStyles((theme)=>({
    root: {
      minWidth: 275,
    },    
    title: {
      fontSize: 28,
    },
    title2: {
        fontSize: 18,
      },
    subTitle2: {
        fontSize: 12,
      },
    pos: {
      marginBottom: 12,
    },
    addButton: {
        marginRight: theme.spacing(2),       
      },
    altura2: {
        minHeight: 70,    
        marginTop:0,
        paddingTop:0,    
    },
    altura3: {
        minHeight: 100,
        marginTop:0,
        paddingTop:0,    
    },
    altura1: {
        height: 90,        
    },
  }));

const RentaMaquinaria = () => {
    const history = useHistory();
    const classes = useStyles();
    const nvlSNPermiso ='5'  
    const source = axios.CancelToken.source();
    const idusu= localStorage.getItem('UsuId');
    const {usuario,guardarUsuario}=useContext(AuthContext);
    const {guardarGenerales}= useContext(GeneralesContext);          
    const [ordenSeleccionada,setOrdenSeleccionada]= useState([])
    const [ordenBusq, setOrdenBusq] =  useState({orden:''});
    const [filtro, setFiltro]=  useState({folio:'', Tipo:""});
    const [fechasSeleccionadas, setFechasSeleccionadas] = useState({inicio:new Date(),final:new Date()});    
    const [estatus, setEstatus] = useState(0);    
    const [buscar, setBuscar] = useState(true);    
    const [modalNvo, setModalNvo] = useState(false);            
    const [modalEdit, setModalEdit] = useState(false);            
    const [modalNvoProv, setModalNvoProv] = useState(false);    
    const [listStatus, setListStatus] = useState([]) 
    const [listUbic, setListUbic] = useState([]) 
    const [listTipo, setListTipo] = useState([]) 
    const [datos, setDatos] = useState([])
    const [cargaEdit, setCargaEdit] = useState(false)
  
    const {folio, Tipo, }=filtro;

    useEffect(()=>{ 

		const veriSesion =  () => {            
            const usu= localStorage.getItem('UsuarioNom');
            const nvl= localStorage.getItem('Tipo');   
            if(usu === null)
            {                                
                guardarUsuario([])						
                guardarGenerales([])     
                localStorage.clear();           
                history.push("/")	
            }
            else
            {   if (usuario.length === 0) 
                {   guardarUsuario({Nombre:usu,nivel:nvl});                                      
                }
                
                guardarGenerales({Titulo:'Renta de Maquinaria  '})  
                                  
                if (listStatus.length === 0) 
                {
                    llenarListStatus();  
                }        
                if (listTipo.length === 0) {
                    llamarTipo()
                }   
             
                
            }
        }
	    veriSesion();	
        return ()=> {
            source.cancel();
        } 

    },[]);

    const llamarTipo = () => {      
        const data = qs.stringify({
            Usuario:idusu,
            idDispositivo:'89y7gttvjhj98h'
        });
        const url = "/renta/tipo";
        function respuestaListInterv(auxiliar) {
            if (auxiliar[0].Id!==-1 ) 
            {                
            let auxArre=[];                 
            auxiliar.map((tipo) => {
            
                auxArre.push({ value : tipo.Id, label :tipo.Descr })  
                    
            })                              
            setListTipo(auxArre);                                                         
            }                    
        }
    
        llamadaApiToken(data, url,respuestaListInterv,ErrorGeneral,history,source);
    };   

    const llenarListStatus = () => {      
        const data = qs.stringify({
            Usuario:idusu,
            idDispositivo:'89y7gttvjhj98h'
        });
        const url = "/renta/status";
        function respuestaListTermin(aux) {
            if (aux[0].Id !== -1) 
            { let auxArre=[];                 
            aux.map((tipo) => {
                if (tipo.Id!==0) {
                    auxArre.push({ value : tipo.Id, label :tipo.Descr })        
                }                                          
            })                              
            setListStatus(auxArre);                             
            }
        }            
        llamadaApiToken(data, url, respuestaListTermin,ErrorGeneral,history,source)
    };
 
    const onChange = e =>
    {   let expNopermitida = new RegExp('[#._:$!%-({})/*=?|]');
        let expMenos = new RegExp('-');
        let expMas = new RegExp('[+]');     
        let expCadena = new RegExp('[A-Za-z0-9]');
        if ( ( expCadena.test(e.target.value) && !expNopermitida.test(e.target.value) &&
            !expMenos.test(e.target.value) && !expMas.test(e.target.value) ) ||e.target.value===' '||e.target.value==='') 
        {
            setFiltro({
                ...filtro,
                [e.target.name] : e.target.value.trim()  
            })
        }
        
    };

    const onChangeSelected = e =>
    {
      setFiltro({
        ...filtro, [e.target.name] : e.target.value  
      })
    };

    const incrementarBuscar = e =>
    {   setBuscar(!buscar)    
    }; 

    const onChangeEstatus = (event) => 
    {   setEstatus(event.target.value );       
        console.log(event.target.value,typeof event.target.value);
    }; 

    function tipoEstado(estado)
    {   let auxEtiqueta=''
        let auxColor=''
        if (estado===0) 
        {   auxEtiqueta='Registrado'
            auxColor='#F46239'
        }
        else
        {
        if (estado === 1) 
        {   auxEtiqueta='Solucionado'
            auxColor='#049b4f'
        }
        else
        {   if (estado === -1) 
            {   auxEtiqueta='Cancelado'
                auxColor='red'
            } 
        }
        }
        let renglon={  color:auxColor,etiqueta:auxEtiqueta}
        return renglon
    }

    const Encabezado=({espacio,estiloCampo,descripcion,campo})=>{
        return(
        <Box {...espacio} >
            <Typography className={classes.title2}  variant="h5" color="secondary" 
                component="h2" align="center"  style={estiloCampo}
            >                                        
                {campo}
            </Typography>                                            
            <Typography  className={classes.subTitle2} color="textSecondary"  align="center" >
                {descripcion }
            </Typography>
        </Box>
        )
    }

    const CampoRenglon=({estiloBox,estiloTitulo,titulo,campo})=>{
        return(
        <Box  {...estiloBox} >
            <span style={estiloTitulo}>{titulo} </span>  
            <Typography variant='body'> {campo}  </Typography>                        
        </Box>
        )
    }

const costadoDerecho =(orden)=>{
    let fecha = moment.utc(orden.FIni);          
    const modificada= fecha.local(true).format("DD/MM/YYYY ");
    let fecha2 = moment.utc(orden.FFin);          
    const modificada2= orden.FFin=== "1900-01-01T00:00:00.000Z"? "": fecha2.local(true).format("DD/MM/YYYY ");
    let arrEstado= tipoEstado(orden.Status)
    let colorTitulo=process.env.REACT_APP_COLOR_SEC
    return(
    <span>
        <Box pl={1} my={1} >
            <Card className={classes.altura3}  >
                <CardContent >
                    <Box display="flex" flexDirection="row"  >
                        <Encabezado espacio={{ }} estiloCampo={ {fontWeight: '900'}} 
                            descripcion={""} campo={orden.Poliza} />                                                                                                                                             
                        {/* <Encabezado espacio={{ ml:1 }} estiloCampo={ { fontWeight: '900'}} 
                            descripcion={""} campo={orden.TipoNom} />     */}                          
                        <Encabezado espacio={{ ml:1 }} estiloCampo={ { fontWeight: '900'}} 
                            descripcion={"Tipo"} campo={orden.TpNom} />
                        <Encabezado espacio={{ ml:1 }} estiloCampo={ {color:orden.StCol,fontWeight:700}} 
                            descripcion={"Proveedor"} campo={orden.ProvNom} />  
                        <Encabezado espacio={{ ml:1 }} estiloCampo={ {fontWeight: '900'}} 
                            descripcion={"Fecha Inicio"} campo={modificada} />
                        {modificada2.length!==0?
                        <Encabezado espacio={{ ml:1 }} estiloCampo={ {fontWeight: '900'}} 
                            descripcion={"Fecha Final"} campo={modificada2} />
                        :null    }
                        <Encabezado espacio={{ ml:1 }} estiloCampo={ {fontWeight: '900'}} 
                            descripcion={"Importe"} campo={<>$<NumberFormat value={orden.Importe} displayType={'text'}  thousandSeparator={true}/></> } />
                        <Encabezado espacio={{ ml:1 }} estiloCampo={ {fontWeight: '900'}} 
                            descripcion={"Impuesto"} campo={<>$<NumberFormat value={orden.Impuesto} displayType={'text'}  thousandSeparator={true}/></>} />
                        <Encabezado espacio={{ ml:1 }} estiloCampo={ {fontWeight: '900'}} 
                            descripcion={"Total"} campo={<>$<NumberFormat value={orden.Importe+orden.Impuesto} displayType={'text'}  thousandSeparator={true}/></>} />
                    </Box>     
                    {orden.ProvDomNom.length!==0 ?
                        <CampoRenglon estiloBox={{display:"flex"}} titulo="Dirección Proveedor" campo={orden.ProvDomNom} 
                            estiloTitulo={{color:colorTitulo,fontWeight:700,paddingRight:0.2+'rem' }}
                        />                                                                                      
                    :null}               
                    {orden.Nota.length!==0 ?
                        <CampoRenglon estiloBox={{display:"flex"}} titulo="Nota " campo={orden.Nota} 
                            estiloTitulo={{color:colorTitulo,fontWeight:700,paddingRight:0.2+'rem' }}
                        />                                                                                      
                    :null}                                              
                                                                              
                </CardContent>                     
            </Card>
        </Box>                    
        <RepoTab orden={orden}  listStatus={listStatus}   listTipo={listTipo} />                             
    </span>)
}

const abrirModNvo=()=>{
    setModalNvo(true)
}
const modNvo =  modalNvo ? <NuevaOrden titulo={"Nuevo Registro"} modalAbierto={modalNvo} setModalAbierto={setModalNvo} 
                            listStatus={listStatus}   listTipo={listTipo}  actualizar={incrementarBuscar}/> :null
const modNvoProd =  modalNvoProv ? <ModalNvoProveedor titulo={"Nuevo Proveedor"} modalAbierto={modalNvoProv} setModalAbierto={setModalNvoProv} 
                            listStatus={listStatus}   listTipo={listTipo}  actualizar={incrementarBuscar}/> :null
const modEdit =  modalEdit ? <NuevaOrden titulo={"Editar Registro"} modalAbierto={modalEdit} setModalAbierto={setModalEdit} 
                                datos={datos} listStatus={listStatus}  listTipo={listTipo} 
                                setDatos={setDatos}
                                setCargaEdit={setCargaEdit} actualizar={incrementarBuscar} auxRegis={ordenSeleccionada}
                            /> :null                                                                
const contenido = ordenSeleccionada.length!=0 ?(costadoDerecho(ordenSeleccionada)):(null)
const principal=()=>{
    //console.log(auxTotal);
    return(
        <Box display="flex" flexDirection="column" >
            <Box style={{}} >
                <Card className={classes.altura2}  >
                    <CardContent style={{padding:0,marginTop:.6+'rem',marginBottom:.5+'rem'}} >
                        <Box display="flex" flexDirection="row" >
                            <Box ml={1} >                                            
                                { usuario?.nivel !=undefined && usuario.nivel!== nvlSNPermiso && findNumber('|34|') ?
                                    <IconButton size={"small"} color="primary"  
                                        aria-label="add circle" component="span" 
                                        onClick={abrirModNvo} style={{marginTop:.6+'rem'}}
                                    >
                                        <AddCircleOutlineIcon/>
                                    </IconButton>        
                                    :   null                                
                                }
                            </Box>                                                                  
                            <Box mr={1.5} >
                                <IconButton color="primary"  aria-label="add circle" size={"small"}
                                    component="span" onClick={incrementarBuscar} style={{marginTop:.6+'rem'}}
                                >
                                    <SearchIcon/>
                                </IconButton>                                                                                                                              
                            </Box>
                            <Box >                                                                          
                                {/* listStatus.length !==0 ? 
                                    <FormControl component="fieldset" style={{width:8+'rem',marginLeft:.5+'rem'}} size="small">   
                                        <InputLabel htmlFor="estatus1-native"> Estatus </InputLabel>                                           
                                        <MaterialSelect
                                            native value={estatus} onChange={onChangeEstatus}
                                            inputProps={{ name: 'estatus', id: 'estatus'}}
                                        >
                                        {listStatus.map((status,index) =>{
                                            return(
                                            <option value={status.value} id={index}>
                                                {status.label}</option>
                                            )
                                            
                                        })}   
                                        </MaterialSelect>                                               
                                    </FormControl>  
                                :null  */}
                                <Box   component="span" >                                                                                                                                                                               
                                    {/* <Relojes fechasSeleccionadas={fechasSeleccionadas} 
                                        setFechasSeleccionadas={setFechasSeleccionadas} /> */}
                                    { listTipo.length !== 0 ?
                                        <FormControl className={classes.formControl} size="small" style={{marginLeft:1+'rem'}} >
                                        <InputLabel htmlFor="age-native-simple">Tipo</InputLabel>
                                        <MaterialSelect
                                            native value={Tipo} onChange={onChangeSelected}
                                            inputProps={{ name: 'Tipo', id: 'Tipo',}}
                                        >
                                            <option aria-label="None" value="" />                     
                                            {listTipo.map((row,index) => (
                                            <option value={row.value} key={index} >{row.label}</option>
                                            ))}   
                                        </MaterialSelect>
                                        </FormControl>     
                                    :null  }  
                                    <TextField id="outlined-basic" label="Folio" variant="outlined" 
                                        size="small" style={({width:8+"rem",marginTop: .3+'rem',marginLeft:.4+'rem'})} 
                                        name="folio" value={folio} onChange={onChange}                                                   
                                    />  
                                    <Button onClick={()=>setModalNvoProv(true)} variant='outlined' style={{marginTop:".5rem", marginLeft:".5rem"}} color='primary'>Nuevo Proveedor</Button> 
                                </Box>                                                                                               
                            </Box>                                                        
                        </Box>                                                                                                        
                    </CardContent>                                
                </Card>
            </Box>  
            <Box  display="flex" flexDirection="row">                
                <Box width="47%"  >                                                        
                    <Box  mt={1} >
                        <TablaRenta   fSeleccionadas={fechasSeleccionadas} 
                            setOrdenSeleccion={setOrdenSeleccionada} cargaEdit={cargaEdit}   
                           
                            buscar={buscar} usuarioContxt={usuario} estatus={estatus}
                            setModalEdit={setModalEdit} datos={datos}  setDatos={setDatos}
                            Tipo={Tipo} folio={folio}
                        />                       
                    </Box>
                </Box>                    
                <Box width="53%"   >                        
                    {contenido}
                </Box> 
            </Box>                
        </Box>      
    )
}

    return (
        <div>
            {principal()}
            {modNvo}
            {modNvoProd}
            {modEdit}
        </div>
    )
}

export default RentaMaquinaria
